module.exports = __webpack_public_path__ + "static/media/loading_color.ea549cef.svg";